import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Why Chiropractic', href: '#why-chiropractic' },
    { name: 'FAQ', href: '#faq' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-cream/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'
      }`}
      style={{
        backgroundColor: "#ffffff"
      }}>
      <div className="container-custom flex justify-between items-center">
        <a
          href="#"
          className="text-2xl font-serif font-bold text-forest tracking-tight"
          style={{
            color: "#4f5a33"
          }}>Huerta Chiropractic</a>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-forest hover:text-forest-light font-medium transition-colors text-sm tracking-wide uppercase"
              style={{
                color: "#4f5a33"
              }}>
              {link.name}
            </a>
          ))}
          <a
            href="#contact"
            className="bg-forest text-cream px-6 py-2.5 rounded-sm font-medium hover:bg-forest-light transition-colors duration-300 text-sm tracking-wide uppercase"
            style={{
              backgroundColor: "#4f5a33"
            }}>
            Book Now
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-forest focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>
      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-cream shadow-lg py-8 px-4 flex flex-col space-y-4 border-t border-divider">
          {navLinks.map((link) => (
            <a 
              key={link.name} 
              href={link.href} 
              className="text-forest text-lg font-medium text-center py-2 hover:text-forest-light"
              onClick={() => setIsOpen(false)}
            >
              {link.name}
            </a>
          ))}
          <a 
            href="#contact" 
            className="bg-forest text-cream px-6 py-3 rounded-sm font-medium text-center mt-4 uppercase tracking-wide"
            onClick={() => setIsOpen(false)}
          >
            Book Appointment
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
